import HttpService from './HttpService'

export const RegisterUserService = (data) => {
  const http = new HttpService()
  return new Promise((resolve, reject) => {
    http.postData('/users', data)
    .then((response) => {
      return resolve(response.data)
    })
    .catch(err => reject(err))
  })
}

export const LoginUserService = (credentials) => {
  const http = new HttpService()
  const tokenID = "user-token"
  
  return new Promise((resolve, reject) => {
    http.postData('/auth/login', credentials)
      .then(response => {
        localStorage.setItem(
          tokenID,
          JSON.stringify({ data: response.data.data, }),
        )
        return resolve(response.data)
      })
      .catch(err => reject(err))
  })
}

export const AuthorizeUserService = () => {
  const http = new HttpService()
  const tokenID = "user-token"
  
  return new Promise((resolve, reject) => {
    http.postData(
      '/auth/authorise',
      null,
      tokenID,
    )
      .then(response => {
        return resolve(response.data)
      })
      .catch(err => reject(err))
  })
}

export const LogoutUserService = () => {
  const http = new HttpService()
  const tokenID = "user-token"
  return http.deleteData(
    '/auth/logout',
    tokenID,
  )
    .then((response) => {
      if (null !== localStorage.getItem(tokenID)) {
        localStorage.removeItem(tokenID)
      }
      window.location = "/"
      return response.data
    })
    .catch(err => err)
}